const LINKED_USER_ACCOUNT_LIST_FILTER = {
  ALL: 'ALL',
  NON_T2E_ONLY: 'NON_T2E_ONLY',
  T2E_ONLY: 'T2E_ONLY',
};

export {LINKED_USER_ACCOUNT_LIST_FILTER};
